<script setup lang="ts"></script>

<template>
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.66705 12.9529L0 7.28588L1.61883 5.66705L5.66877 9.7124L5.66705 9.71412L15.3812 0L17 1.61883L7.28588 11.3341L5.66819 12.9518L5.66705 12.9529Z"
      fill="white"
    />
  </svg>
</template>
